import { render } from "./IsoModal.vue?vue&type=template&id=5ae47de9"
import script from "./IsoModal.vue?vue&type=script&lang=js"
export * from "./IsoModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__